var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{directives:[{name:"tooltip",rawName:"v-tooltip"}],attrs:{"top":!_vm.bottom,"bottom":_vm.bottom,"disabled":!_vm.textTruncated},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('span',_vm._g(_vm._b({staticClass:"tooltip-activator"},'span',attrs,false),on),[_vm._v(_vm._s(_vm.text))])]}}])},[_c('span',{staticClass:"simple-text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }